import classNames from 'classnames';
import React from 'react';
import { Button } from './Button';

export interface AlertProps {
  className?: string;
  variant?: 'success' | 'error' | 'neutral-1' | 'neutral-2';
  button?: {
    label: string;
    onClick: () => void;
  };
  label?: string;
  children?: React.ReactElement;
  icon?: string;
}

export const Alert = ({
  className,
  button,
  variant = 'neutral-1',
  label,
  icon,
  children,
}: AlertProps) => {
  return (
    <div
      className={classNames(
        'w-full min-h-[48px] flex justify-start py-3 px-4 items-center rounded',
        {
          'bg-success-green/[.08]': variant === 'success' && !className?.includes('bg-'),
          'bg-error-red/[.08]': variant === 'error' && !className?.includes('bg-'),
          'bg-gray-900/[.08]': variant === 'neutral-1' && !className?.includes('bg-'),
          'bg-blue-700/[.08]': variant === 'neutral-2' && !className?.includes('bg-'),
          'mb-10': !className?.includes('mb-'),
          'font-[Inter]': !className?.includes('font-'),
          'text-sm': !className?.includes('text-'),
        },
        className,
      )}
    >
      {icon && <img src={icon} alt="..." className="mr-3" />}
      <div className="flex flex-col h-full items-center justify-center">
        <span className="text-gray-900 text-sm whitespace-pre-wrap">
          {children && children}
          {label &&
            label.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line && line}
                {line.length > 1 && index !== label.split('\n').length - 2 && (
                  <>
                    <br />
                  </>
                )}
              </React.Fragment>
            ))}
          {button && (
            <Button variant="secondary" onClick={button.onClick}>
              {button.label}
            </Button>
          )}
        </span>
      </div>
    </div>
  );
};
